import { DispensationReviewView } from "@/components/pages/efteruddannelse/DispensationReviewView";

import type { DecoratedPersonEfteruddannelse } from "./decoratePeriod";

interface DispensationDetailViewProps {
  userId: string;
  dispensationId: string;
  periods: DecoratedPersonEfteruddannelse[];
  onBack: () => void;
}

export const DispensationDetailView = ({
  userId,
  dispensationId,
  periods,
  onBack,
}: DispensationDetailViewProps) => (
  <DispensationReviewView
    userId={userId}
    dispensationId={dispensationId}
    periods={periods}
    onBack={onBack}
  />
);
